import * as React from "react";
import { Suspense } from "react";
import { CrystalBallProspect } from "../../stores";
import Breadcrumbs from "../core/Breadcrumbs";
import PageContainer from "../core/PageContainer";
import { wrapComponentForErrors } from "../utility/ErrorHandler";
import { normalizeUserContextData } from "../../libs/user_context";

const CrystalBallEditor = React.lazy(() =>
  import("../crystal_ball/CrystalBallEditor")
);

interface IProps {
  prospect: IProspectRecord;
  userContext: IUserContextData;
}

interface IState {
  prospect?: CrystalBallProspect;
  userContext: IUserContextNormalized;
}

class CrystalBallProspectNew extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    userContext: normalizeUserContextData(this.props.userContext),
  };

  async componentDidMount() {
    const { CrystalBallProspect } = await import("../../stores");
    const prospect = new CrystalBallProspect();

    const { org } = this.state.userContext;

    if (org.settings && org.settings.minimumWage) {
      prospect.minimumWage = org.settings.minimumWage;
    }

    this.setState({ prospect });
  }

  render() {
    const { prospect, userContext } = this.state;

    if (!prospect) {
      return null;
    }

    const breadcrumbs = [
      { label: "Crystal Ball", route: Routes.crystal_ball_prospects_path() },
      { label: "New Prospect" },
    ];

    return (
      <PageContainer>
        <Breadcrumbs crumbs={breadcrumbs} />
        <Suspense fallback={null}>
          <CrystalBallEditor prospect={prospect} userContext={userContext} />
        </Suspense>
      </PageContainer>
    );
  }
}

export default wrapComponentForErrors(CrystalBallProspectNew);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/ProspectNew.tsx